import { gql } from '@apollo/client';

export default gql`
  query booking($reference: String!) {
    booking(reference: $reference) {
      additionalDetails {
        value
        key
        itemRef
      }
      reference
      outbound(sortByDepartureDate: true) {
        ...leg
      }
      inbound(sortByDepartureDate: true) {
        ...leg
      }
      eurostarBookingItems @client {
        ...product
      }
      isPackage
      hotels {
        itemRef
        priceWithMargin
        cancelled
        provisional
        currency
      }
      payments(excludePayout: true, excludeBalance: true) {
        id
        refId
        currency
        currencyRate
        reference
        externalReference
        refundAvailable
        provider
        method
        amount
        availableRefundAmount
        transactionTimestamp
        refundProcessTimestamp
        paymentStatus
        createdRevision
      }
      passengers {
        email
        firstName
        lastName
      }
      customer {
        email
        firstName
        lastName
      }
    }
  }

  fragment leg on Leg {
    ...legFields
    addOnLeg {
      ...legFields
    }
  }

  fragment legFields on Leg {
    products {
      ...product
    }
    serviceType {
      code
      name
    }
  }

  fragment product on Product {
    itemRef
    currency
    price
    isCancelled
    loyaltyPoints
    productFamily {
      code
      name
      familyGroup
    }
  }
`;
